module.exports = __webpack_public_path__ + "img/wecht.4b84849b.jpg";